<template>
  <div class="dialog" :class="cssType" v-if="props.modelValue">
    <div class="dialog-mask"></div>
    <div class="dialog-content" :class="type">
      <slot></slot>
      <div class="dialog-close" :class="type" @click="handleClose" v-if="showClose"></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  type: { // validateUser, common
    type: String,
    required: true
  },
  showClose: {
    type: Boolean,
    default: true
  }
})

watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    document.body.classList.add('lock-scroll')
  } else {
    document.body.classList.remove('lock-scroll')
  }
}, { immediate: true })

const emit = defineEmits(['update:modelValue'])

const handleClose = () => {
  emit('update:modelValue', false)
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>